import i18n from '@/i18n';

export const EXPORT_FORMATS = ['csv', 'pdf', 'copy'] as const;

export type ExportFormat = (typeof EXPORT_FORMATS)[number];

export const exportFormatLabels: Record<ExportFormat, string> = {
  csv: 'CSV',
  pdf: 'PDF',
  copy: i18n.t('Copy to clipboard'),
};
